import { createFileRoute } from "@tanstack/react-router";
import { ConnectedAgentPage } from "@/components/agents/connected-agent-page";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";

export const Route = createFileRoute("/$owner/agents/connected/$clientId/")({
	component: ConnectedAgentDetailPage,
});

function ConnectedAgentDetailPage() {
	const { owner, clientId } = Route.useParams();
	return (
		<OwnerWorkspaceGate owner={owner}>
			{({ ownerSlug }) => (
				<ConnectedAgentPage owner={ownerSlug} clientId={clientId} />
			)}
		</OwnerWorkspaceGate>
	);
}
